import React, {Component} from 'react'
import './BackOfficeNavMenuComponent.css'
import {Nav, NavItem, NavDropdown, Navbar, MenuItem} from 'react-bootstrap'

export default class BackOfficeNavMenuComponent extends Component {
    render() {
        return(
            <Navbar className="nav-user">
                <Nav className="pull-right">
                    <NavDropdown eventKey={3} title={<span>Notifiche <span className="badge badge-menu">{this.props.thingsToDo.waitingMarks}</span></span>} id="basic-nav-dropdown">
                        {/*<MenuItem eventKey={3.1}>
                            <span className="badge badge-list">
                                {this.props.thingsToDo.waitingUsers ? this.props.thingsToDo.waitingUsers : 0}
                            </span>
                            <strong>Utenti</strong> in attesa</MenuItem>*/}
                        <MenuItem onClick={() => {this.props.onMarksWaitingClick()}} eventKey={3.2}>
                            <span className="badge badge-list">
                                {this.props.thingsToDo.waitingMarks ? this.props.thingsToDo.waitingMarks : 0}
                            </span>
                            <strong>Contrassegni</strong> in attesa di appr.</MenuItem>
                    </NavDropdown>

                    <NavDropdown eventKey={3} title={this.props.user.firstName + " " + this.props.user.lastName} id="basic-nav-dropdown">
                        <MenuItem onClick={this.props.onLogoutClick} eventKey={3.2}>Logout</MenuItem>
                    </NavDropdown>
                </Nav>
            </Navbar>


        );
    }
}


// WEBPACK FOOTER //
// ./src/components/BackOfficeNavMenuComponent.js